import React, { useCallback } from 'react';
import {ReadOnlySupport} from "./utils/ReadOnlySupport";
import {Switch as AntSwitch} from 'antd';

export const Switch = React.forwardRef((props, ref) => {
    const { children } = props;

    const whenReadOnly = useCallback(() => {
        const readOnlyProps = {
            ...props,
            onChange: () => {},
            onClick: () => {},
            disabled: true,
            className: 'ant-custom-readonly ant-switch',
        };

        return (
            <AntSwitch {...readOnlyProps}>
                {children}
            </AntSwitch>
        );
    }, [children, props]);

    const notReadOnly = useCallback(() => (
        <AntSwitch {...props} ref={ref}>
            {children}
        </AntSwitch>
    ), [children, props, ref]);

    return <ReadOnlySupport
        {...props}
        whenReadOnly={whenReadOnly}
        notReadOnly={notReadOnly}
    />;
});
